import { LoadingOverlay } from '@mantine/core'
import { type FC, type PropsWithChildren, Suspense } from 'react'

export interface SuspenseWithLoadingOverlayProps extends PropsWithChildren {}

export const SuspenseWithLoadingOverlay: FC<SuspenseWithLoadingOverlayProps> = ({ children }) => (
  <Suspense fallback={<LoadingOverlay visible />}>{children}</Suspense>
)
